import { Button } from "@minuthq/meatball-ui-react"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useTranslate } from "src/domains/i18n/use-translate"
import backdropImage from "src/ui/assets/buildings-orange-brown.jpg"
import { PageLayout } from "src/ui/page-layout/page-layout"

import { EmailRequestPwForm } from "./-request-reset-pw-form"

export const Route = createFileRoute("/password/reset/")({
  component: RequestPwReset,
})

function RequestPwReset() {
  const navigate = useNavigate()
  const { tPlaceholder } = useTranslate()

  return (
    <PageLayout
      title={tPlaceholder("Reset password")}
      description={tPlaceholder(
        "If we have the email on record we'll send a link where you can choose a new password."
      )}
      footer={
        <Button
          variant="minimal"
          color="neutral"
          size="small"
          onClick={() => {
            void navigate({ to: "/login" })
          }}
        >
          {tPlaceholder("Return to sign in")}
        </Button>
      }
      landscapeImageUrl={backdropImage}
      portraitImageUrl={backdropImage}
    >
      <EmailRequestPwForm />
    </PageLayout>
  )
}
